import React, { ReactElement, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { Topbar, Sidebar } from '../components';

interface MainProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100vw',
    backgroundColor: '#fff',
    position: 'relative',
  },
}));

const Main = (props: MainProps): ReactElement => {
  const { children } = props;

  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
      })}
    >
      <Topbar onSidebarOpen={handleSidebarOpen} />
      <Sidebar onClose={handleSidebarClose} open={open} variant="temporary" />
      <main>{children}</main>
    </div>
  );
};

Main.defaultProps = {
  children: undefined,
};

export default Main;
